import axios from 'axios';
import { ENV_CONFIG } from 'config/environment';
import API_ROUTES from 'services/apiRoutes';
import { getSiteAccessToken } from 'services/storage';

export const downloadGivingHistory = async () => {
  const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.USER_GIVING_HISTORY_DOWNLOAD}`;

  try {
    const { data } = await axios.post(url, null, {
      headers: { Authorization: `Bearer ${getSiteAccessToken()}` },
    });

    const res = await fetch(data.signed_url);
    if (!res.ok) throw new Error(`Signed URL fetch failed: ${res.status}`);
    const file = await res.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(file);
    link.download = 'oath_giving_history.csv';
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (error: any) {
    if (error.response?.status === 400) {
      return Promise.reject(error.response.data?.detail ?? 'Too many donations to download.');
    }
    return Promise.reject('There was an error downloading your history. Please contact support.');
  }
};
